import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { WorkProductIndexResponse } from "../../../shared/types";

export function useOutputs(brandId: string | undefined) {
  return useQuery({
    queryKey: ["outputs", brandId],
    queryFn: () => {
      if (!brandId) throw new Error("Brand is required to load outputs");
      return api.get<{ data: WorkProductIndexResponse }>(
        `/api/outputs?brand_id=${encodeURIComponent(brandId)}&limit=200`,
      );
    },
    enabled: !!brandId,
    staleTime: 10_000,
  });
}
